module.exports = __webpack_public_path__ + "img/unlock.bf38256d.svg";